import axios from "axios";
import {
  buildCubeFiltersFromFilterModule,
  filterModuleHasContent,
} from "./cubeFilters";

export function slotHasActivePerfFilter(slot) {
  return Boolean(
    filterModuleHasContent(slot?.perfFilter?.filterModuleFilters) ||
      slot?.perfFilter?.cubeFilters?.trim()
  );
}

/** Same cube query as save payload — used for campaign:insights preview. */
export function resolveSlotCubeFiltersJson(slot, { platformCampaignIds = [], userPlatform = "amazon" } = {}) {
  const existing = slot?.perfFilter?.cubeFilters?.trim();
  if (existing) return existing;
  if (!filterModuleHasContent(slot?.perfFilter?.filterModuleFilters)) return "";
  return (
    buildCubeFiltersFromFilterModule(slot.perfFilter.filterModuleFilters, {
      timePeriod: slot.perfFilter?.timePeriod ?? "LAST_7_DAY",
      platformCampaignIds,
      userPlatform,
    }) || ""
  );
}

export function parseInsightsRequestBody(cubeFiltersJson) {
  if (!cubeFiltersJson?.trim()) return null;
  try {
    const parsed = JSON.parse(cubeFiltersJson);
    if (parsed?.query && typeof parsed.query === "object") return { query: parsed.query };
    if (parsed?.measures) return { query: parsed };
    return null;
  } catch {
    return null;
  }
}

/**
 * POST campaign:insights with full filter query from cube_filters.
 * Returns platform campaign_id values that match the performance filter.
 */
export async function fetchPerfFilterImpactedCampaignIds({
  clientId,
  userPlatform = "amazon",
  cubeFiltersJson,
  signal,
  minLimit = 50,
}) {
  const body = parseInsightsRequestBody(cubeFiltersJson);
  if (!body?.query || !clientId) return [];

  const requestedLimit = Math.max(Number(body.query.limit) || 50, minLimit);
  body.query.limit = requestedLimit;

  const { data } = await axios.post(
    `${process.env.REACT_APP_REPORT_API}/client/${clientId}/campaign:insights?source=${userPlatform}`,
    body,
    {
      headers: { "Content-Type": "application/json" },
      signal,
    }
  );

  const rows = Array.isArray(data?.data) ? data.data : [];
  return rows.map((row) => String(row?.campaign_id ?? "")).filter(Boolean);
}

export function isCampaignImpactedByPerfFilter(mongoId, impactedPlatformIds, campaignMeta) {
  const platformId = campaignMeta?.[mongoId]?.platformId;
  if (!platformId) return false;
  const set =
    impactedPlatformIds instanceof Set
      ? impactedPlatformIds
      : new Set((impactedPlatformIds ?? []).map(String));
  return set.has(String(platformId));
}

export function countSelectedCampaignsMatchingPerfFilter(
  selectedCampaignIds,
  impactedPlatformIds,
  campaignMeta
) {
  return (selectedCampaignIds ?? []).filter((mid) =>
    isCampaignImpactedByPerfFilter(mid, impactedPlatformIds, campaignMeta)
  ).length;
}
